/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import {
  Checkbox,
  //Loader,
  Modal,
  Radio,
  Dropdown,
  Form,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Update from 'immutability-helper';
import api from '../../api';
//import ClarLoader from '../Loader/Loader';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import { convertWithScanOptionText, sortValueofAtoZ } from '../../constants/ScanOptionText';

class ScanOptionModal extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.state = {
      isLoading: false,
      isOpenAlert: false,
      isOpenSaveModal: false,
      scanOptionsWithArray: [],
      scanOptionsWithBoolean: [],
      scanOptionsWithString: [],
    };
    this.applyScanOption = this.applyScanOption.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleStringInputChange = this.handleStringInputChange.bind(this);
    this.handleToggleRadio = this.handleToggleRadio.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleStringAddition = this.handleStringAddition.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeSaveModal = this.closeSaveModal.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    const { isOpenMSO } = this.props;
    if (isOpenMSO !== prevProps.isOpenMSO) {
      this.setState({
        isLoading: false,
        isOpenAlert: false,
        isOpenSaveModal: false,
        scanOptionsWithArray: [],
        scanOptionsWithBoolean: [],
        scanOptionsWithString: [],
      });
      if (isOpenMSO) {
        this.checkScanOption();
      }
    }
  }

  handleSave = () => {
    const { t } = this.props;
    const {
      scanOptionsWithArray,
    } = this.state;
    let openAlert = false;

    const options = scanOptionsWithArray.map((o) => {
      const filteredItem = o.items.filter((f) => {
        return !f.selected;
      });

      if (filteredItem.length === o.items.length) {
        openAlert = true;
        return openAlert;
      }
      openAlert = false;
      return openAlert;
    });

    if (options.indexOf(true) > -1) {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('modal.new_scan.error.error_option_select_category');
      return this.setState({
        isOpenAlert: true,
      });
    }

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('my_page.save_scan_option');
    this.setState({
      isOpenSaveModal: true,
    });
  };

  handleCheckChange = (e, selectedEntity, optionIndex, itemsIndex) => {
    const { scanOptionsWithArray } = this.state;
    const cloneArray = [...scanOptionsWithArray];

    const itemsArray = cloneArray[optionIndex].items;
    const updatedArray = Update(itemsArray[itemsIndex], { selected: { $set: !selectedEntity.selected } });
    const newData = Update(itemsArray, {
      $splice: [[itemsIndex, 1, updatedArray]],
    });

    cloneArray[optionIndex] = { ...cloneArray[optionIndex], items: newData };

    this.setState({
      scanOptionsWithArray: cloneArray,
    });
  };

  handleToggleRadio = (e, entity, option, index) => {
    const { scanOptionsWithBoolean } = this.state;
    const cloneArray = [...scanOptionsWithBoolean];

    const updatedItems = Update(cloneArray[index], { items: { $set: !entity } });
    const newData = Update(cloneArray, {
      $splice: [[index, 1, updatedItems]],
    });

    this.setState({
      scanOptionsWithBoolean: newData,
    });
  };

  handleStringInputChange = (e, items, index) => {
    const { scanOptionsWithString } = this.state;
    const cloneArray = [...scanOptionsWithString];
    if (e.target.classList[0] === 'search') {
      cloneArray[index].items.push(e.target.value);

      this.setState({
        scanOptionsWithString: cloneArray,
      });
    } else if (e.target.classList[0] === 'selected') {
      cloneArray[index].items.push(e.target.querySelector('b').textContent);

      this.setState({
        scanOptionsWithString: cloneArray,
      });
    } else {
      const filteredItems = cloneArray[index].items.filter((item) => {
        return item !== e.target.closest('.label').text;
      });

      const filteredOptions = cloneArray[index].selected_array.filter((item) => {
        return item.text !== e.target.closest('.label').text;
      });

      this.setState({
        scanOptionsWithString: Update(cloneArray, {
          [index]: {
            items: { $set: filteredItems },
            selected_array: { $set: filteredOptions },
          }
        })
      });
    }
  };

  handleStringAddition = (e, entity, index) => {
    const { scanOptionsWithString } = this.state;
    const cloneArray = [...scanOptionsWithString];

    let data;

    if (e.target.value) {
      data = {
        key: e.target.value,
        text: e.target.value,
        value: e.target.value,
      };
    } else {
      data = {
        key: e.target.querySelector('b').textContent,
        text: e.target.querySelector('b').textContent,
        value: e.target.querySelector('b').textContent,
      };
    }

    const checkUnique = cloneArray[index].selected_array.filter((item) => {
      return item.key === data.key;
    });

    if (checkUnique.length !== 0) {
      return;
    }

    cloneArray[index].selected_array.push(data);

    this.setState({
      scanOptionsWithString: cloneArray,
    });
  };

  getNewScanOption() {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getNewScanOption()
        .then((res) => {
          const data = res.response;

          const scanOptionsWithArrayRes = [];
          const scanOptionsWithBooleanRes = [];
          const scanOptionsWithStringRes = [];

          data.map((option) => {
            if (Array.isArray(option.items)) {
              return scanOptionsWithArrayRes.push(option);
            }
            if (typeof option.items === 'boolean' || option.items instanceof Boolean) {
              return scanOptionsWithBooleanRes.push(option);
            }
            let selectedValue = [];
            let optionList = [];
            if (option.items !== '') {
              const splitWords = option.items.split(':');
              const newArray = splitWords.map((item) => {
                selectedValue.push(item);
                return {
                  key: item,
                  text: item,
                  value: item,
                };
              });
              optionList = newArray;
            } else {
              optionList = [];
              selectedValue = [];
            }
            const newData = {
              display_option: option.display_option,
              items: selectedValue,
              selected_array: optionList,
              option: option.option,
            };

            return scanOptionsWithStringRes.push(newData);
          });

          this.setState({
            scanOptionsWithArray: scanOptionsWithArrayRes,
            scanOptionsWithBoolean: scanOptionsWithBooleanRes,
            scanOptionsWithString: scanOptionsWithStringRes,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  checkScanOption() {
    const { defaultScanOptions } = this.props;

    if (Object.keys(defaultScanOptions).length === 0) {
      this.getNewScanOption();
    } else {
      this.generateScanOption();
    }
  }

  generateScanOption() {
    const { defaultScanOptions } = this.props;
    const { type, manifest, extension } = defaultScanOptions;

    this.setState({
      scanOptionsWithArray: type,
      scanOptionsWithBoolean: manifest,
      scanOptionsWithString: extension,
    });
  }

  applyScanOption() {
    const {
      scanOptionsWithArray,
      scanOptionsWithBoolean,
      scanOptionsWithString,
    } = this.state;
    const { applyScanOption } = this.props;
    const newOptions = {};

    scanOptionsWithArray.map((entity) => {
      let i = 0;
      const items = [];
      for (i; i < entity.items.length; i++) {
        if (entity.items[i].selected) {
          items.push(entity.items[i].item);
        }
      }
      newOptions[entity.option] = items;
      return null;
    });

    scanOptionsWithBoolean.map((entity) => {
      newOptions[entity.option] = entity.items;
      return null;
    });

    scanOptionsWithString.map((entity) => {
      let newItems;
      entity.items.map((item, index) => {
        if (index === 0) {
          newItems = `${item}`;
        } else {
          newItems = `${newItems}:${item}`;
        }
        return newItems;
      });
      newOptions[entity.option] = newItems || '';
      return null;
    });

    const bak = {
      type: scanOptionsWithArray,
      manifest: scanOptionsWithBoolean,
      extension: scanOptionsWithString,
    };
    applyScanOption(newOptions, bak);
  }

  closeModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  closeSaveModal() {
    this.setState({
      isOpenSaveModal: false,
      isOpenAlert: false,
    });
  }

  render() {
    const {
      t,
      isOpenMSO,
    } = this.props;
    const {
      isOpenSaveModal,
      isOpenAlert,
      isLoading,
      scanOptionsWithArray,
      scanOptionsWithBoolean,
      scanOptionsWithString,
    } = this.state;

    const renderItems = (array, optionIndex) => {
      if (Array.isArray(array)) {
        const newArray = sortValueofAtoZ(array);
        return newArray.map((entity, itemsIndex) => {
          return (
            <Form.Field key={entity.item}>
              <Checkbox
                label={convertWithScanOptionText(entity.item)}
                value={entity.item}
                checked={entity.selected}
                onChange={
                  (e) => {
                    return this.handleCheckChange(e, entity, optionIndex, itemsIndex);
                  }
                }
              />
            </Form.Field>
          );
        });
      }
    };

    return (
      <Modal
        open={isOpenMSO}
        onClose={this.closeModal}
      >
        <div className="setting_popup_wrap">
          <div className="setting_popup default_popup">
            <div className="setting_popup_header">
              <h2 className="popup_name">
                {t('my_page.set_scan_options')}
              </h2>
              <a
                className="popup_close_button"
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                <img src={closeBtn} alt="" />
              </a>
            </div>
            <Scrollbars
              style={{
                height: '490px',
                overflow: 'hidden',
                position: 'relative',
              }}
              renderTrackHorizontal={() => {
                return <div />;
              }}
              renderThumbHorizontal={() => {
                return <div />;
              }}
            >
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <Form
                    loading={isLoading}
                  >
                    <h3>
                      {t('modal.new_scan.title.scan_options_type')}
                    </h3>
                    {
                      scanOptionsWithArray.length !== 0
                    && (
                      <Form.Group widths="equal" style={{ marginTop: '30px' }}>
                        {

                          scanOptionsWithArray.map((list, index) => {
                            return (
                              <Form.Field key={list.option}>
                                <label style={{ marginBottom: '1rem' }}>{list.display_option}</label>
                                {renderItems(list.items, index)}
                              </Form.Field>
                            );
                          })
                        }
                      </Form.Group>
                    )
                    }
                    {
                      (scanOptionsWithBoolean.length !== 0 || scanOptionsWithString.length !== 0)
                    && <div className="line" />
                    }
                    {
                      scanOptionsWithBoolean.length !== 0
                    && (
                      <Form.Group widths="equal" style={{ marginTop: '30px' }}>
                        {
                          scanOptionsWithBoolean.map((list, index) => {
                            return (
                              <Form.Field key={list.option}>
                                <label style={{ marginBottom: '1rem' }}>{list.display_option}</label>
                                <Radio
                                  toggle
                                  checked={list.items}
                                  onChange={
                                    (e) => {
                                      return this.handleToggleRadio(e, list.items, list.option, index);
                                    }
                                  }
                                />
                              </Form.Field>
                            );
                          })
                        }
                      </Form.Group>
                    )
                    }
                    {
                      (scanOptionsWithArray.length !== 0 || scanOptionsWithString.length !== 0)
                    && <div className="line" />
                    }
                    {
                      scanOptionsWithString.length !== 0
                    && (
                      <Form.Group widths="equal" style={{ marginTop: '30px' }}>
                        {
                          scanOptionsWithString.map((list, index) => {
                            return (
                              <Form.Field key={list.option}>
                                <label style={{ marginBottom: '1rem' }}>{list.display_option}</label>
                                <Dropdown
                                  multiple
                                  selection
                                  allowAdditions
                                  additionLabel={t('modal.button.add')}
                                  fluid
                                  search
                                  options={list.selected_array}
                                  value={list.items}
                                  onChange={
                                    (e) => {
                                      return this.handleStringInputChange(e, list.items, index);
                                    }
                                  }
                                  onAddItem={
                                    (e) => {
                                      return this.handleStringAddition(e, list, index);
                                    }
                                  }
                                  noResultsMessage={null}
                                />
                              </Form.Field>
                            );
                          })
                        }
                      </Form.Group>
                    )
                    }
                  </Form>
                </div>
              </div>
            </Scrollbars>
            <div className="setting_popup_button_wrap">
              <a
                className="button cencel_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                {t('modal.button.cancel')}
              </a>
              <a
                className="button save_button"
                style={{ cursor: 'pointer' }}
                onClick={this.handleSave}
                onKeyUp={this.handleSave}
              >
                {t('modal.button.apply')}
              </a>
            </div>
          </div>
        </div>
        <Modal open={isOpenSaveModal} onClose={this.closeSaveModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a className="left_button" onClick={this.closeSaveModal} onKeyUp={this.closeSaveModal}>
                    {t('modal.button.cancel')}
                  </a>
                  <a className="right_button" onClick={this.applyScanOption} onKeyUp={this.applyScanOption}>
                    {t('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={isOpenAlert} onClose={this.closeSaveModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeSaveModal}
                    onKeyUp={this.closeSaveModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}
export default withTranslation()(inject('state')(observer(ScanOptionModal)));
